import React, { useState, useCallback, useEffect, Component } from 'react';
import LayoutHeader from '../Inc/Header';
import moment from 'moment';
import AdminNavigation from '../Inc/AdminNavigation';
import * as actions from '../../actions/index';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import ActivateMembership from './ActivateMembership'
import ViewMembership from './ViewApplication'
import debounce from 'lodash.debounce';
import FAQ from '../Inc/FAQ';
import { Input, Modal, Button, Tabs, Form, Table, Pagination,Popconfirm, Spin, Icon, Tooltip, Badge, Row, Col } from 'antd';
import { compose } from 'recompose';
import Skeleton from 'react-loading-skeleton';
import SearchAlumniFilter from '../Inc/SearchAlumniFilter';
import { history } from '../../container/History';
import InputMask from 'react-input-mask'
import warningAlert from './warning-alert.png'

import Refetch from 'fetch-retry'

import { CSVLink, CSVDownload } from "react-csv";
import { getActiveTransaction } from '@sentry/react/dist/profiler';

const FormItem = Form.Item;
const _ = require('lodash')
const TabPane = Tabs.TabPane;
const LoadingIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

class PendingMembershipForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            SearchPending: "",
            SearchProcessed: "",
            SearchDenied: "",
            pendingpage: 1,
            pendingpagesize: 10,
            deniedpage: 1,
            deniedpagesize: 10,
            processedpage: 1,
            processedpagesize: 10,
            modalVisible: false,
            membershipType: undefined,
            Download_CSV_modal_Visible: false,
            Max_CSV_Records_Modal_Visible: false,
            NESAMembershipsPending: [],
            fromDateCustom_err : undefined,
            ToDateCustom_err : undefined,
            startDate : null,
            endDate : null,
            activeTabKey: "2",
            // CSVcustom_err : {
            //     pending: {fromDateErrMsg: undefined, toDateErrMsg: undefined},
            //     processed: {fromDateErrMsg: undefined, toDateErrMsg: undefined},
            //     denied: {fromDateErrMsg: undefined, toDateErrMsg: undefined},
            // }
        }
        this.viewpending = this.viewpending.bind(this)
        this.SearchPending = this.SearchPending.bind(this)
        this.SearchProcessed = this.SearchProcessed.bind(this)
        this.SearchDenied = this.SearchDenied.bind(this)
        this.filtercallback = this.filtercallback.bind(this)
        this.showTotal = this.showTotal.bind(this)
        this.onShowSizeChangedenied = this.onShowSizeChangedenied.bind(this)
        this.onShowSizeChangepending = this.onShowSizeChangepending.bind(this)
        this.onShowSizeChangeprocessed = this.onShowSizeChangeprocessed.bind(this)
        this.deniedcolumns = [{
            title: 'Applicant Name',
            dataIndex: 'applicantFullName',
            key: 'applicantFullName',
            render: (text, record) => (
                <div className='action-panel'>
                    <span>{record.firstName != "" ? record.lastName +", "+ record.firstName : ""}</span>
                </div>
            )
        }, 
        // {
        //     title: 'Organization',
        //     dataIndex: 'currentOwnerOrgName',
        //     key: 'currentOwnerOrgName',
        // }, {
        //     title: 'Email',
        //     dataIndex: 'emailAddress',
        //     key: 'emailAddress',
        // },
        {
            title: 'Denied Date',
            dataIndex: 'lastModifiedDate',
            key: 'lastModifiedDate',
            render: (text, record) => (
                <div className='action-panel'>
                    <span>{moment(record.lastModifiedDate).format('MM/DD/YYYY')}</span>
                </div>
            )
        },
        {
            title: 'Membership Type',
            dataIndex: 'alumniMembershipLevelId',
            key: 'alumniMembershipLevelId',
            render: (text, record) => (
                <div className='action-panel'>
                    {record.alumniMembershipLevelId == 30 && <span>NESA 5 Yrs</span>}
                    {record.alumniMembershipLevelId == 32 && <span>NESA Lifetime</span>}
                </div>
            )
        },
        {
            title: 'Rush Shipping',
            dataIndex: 'isRush',
            key: 'isRush',
            render: (text, record) => (
                <div className='action-panel'>
                    <span>{record.isRush ? "YES" : "NO"}</span>
                </div>
            )
        },
        {
            title: 'Actions',
            dataIndex: 'Actions',
            key: 'Actions',
            render: (text, record) => (
                <div className='action-panel'>
                    <div>
                        <Tooltip placement="top" title="View Membership">
                            <Button onClick={() => this.showMembership(record.id)} style={{ }} type="primary" > View Application</Button>
                        </Tooltip>
                    </div>

                    <div>
                        <Popconfirm placement="top" title="Are you sure to move this?" onConfirm={() => this.props.actions.denyToPendingMembership(record.id)} okText="Yes" cancelText="No">
                            <Button type="primary" style={{ backgroundColor: '#36aa2c', borderColor: '#36aa2c', }} > Reverse To Pending </Button>
                        </Popconfirm>
                        {/* <Tooltip placement="top" title="View Membership">
                            <Button onClick={() => this.props.actions.denyToPendingMembership(record.id)} type="primary" style={{backgroundColor: '#36aa2c' , borderColor: '#36aa2c', }} > Move To Pending </Button>
                        </Tooltip> */}
                    </div>
                </div>
            )
        },
        // {
        //     title: 'Move to Pending',
        //     dataIndex: 'MoveToPending',
        //     key: 'MoveToPending',
        //     render: (text, record) => (
        //         <div className='action-panel'>
        //             <div>
        //                 <Tooltip placement="top" title="View Membership">
        //                     <Button onClick={() => this.props.actions.denyToPendingMembership(record.id)} type="primary" style={{backgroundColor: '#039a3d' , borderColor: '#039a3d'}} > Move </Button>
        //                 </Tooltip>
        //             </div>
        //         </div>
        //     )
        // },
    ]
        this.processedcolumns = [{
            title: 'Applicant Name',
            dataIndex: 'applicantFullName',
            key: 'applicantFullName',
            render: (text, record) => (
                <div className='action-panel'>
                    <span>{record.firstName != "" ? record.lastName +", "+ record.firstName : ""}</span>
                </div>
            )
        }, {
            title: 'Member ID',
            dataIndex: 'memberID',
            key: 'memberID',
            render: (text, record) => (
                <div className='action-pane'>
                    <span>{record.memberID ? record.memberID : ''}</span>
                </div>
            )
        }, {
            title: 'Email',
            dataIndex: 'emailAddress',
            key: 'emailAddress',
            render: (text, record) => (
                <div className='action-pane'>
                    <span>{record.email ? record.email : ''}</span>
                </div>
            )
        },
        {
            title: 'Accepted Date',
            dataIndex: 'acceptedDate',
            key: 'acceptedDate',
            render: (text, record) => (
                <div className='action-panel'>
                    <span>{record.acceptedDate !== null ? moment(record.acceptedDate).format('MM/DD/YYYY') : null}</span>
                </div>
            )
        },
        {
            title: 'Membership Type',
            dataIndex: 'alumniMembershipLevelId',
            key: 'alumniMembershipLevelId',
            render: (text, record) => (
                <div className='action-panel'>
                    {record.alumniMembershipLevelId == 30 && <span>NESA 5 Yrs</span>}
                    {record.alumniMembershipLevelId == 32 && <span>NESA Lifetime</span>}
                </div>
            )
        },
        // {
        //     title: 'Rush Shipping',
        //     dataIndex: 'isRush',
        //     key: 'isRush',
        //     render: (text, record) => (
        //         <div className='action-panel'>
        //             <span>{record.isRush ? "YES" : "NO"}</span>
        //         </div>
        //     )
        // },
        {
            title: 'Total Amount',
            dataIndex: 'totalAmountPaid',
            key: 'totalAmountPaid',
            render: (text, record) => (
                <div className='action-pane'>
                    {/* <span> 
                        {record.totalAmountPaid != null 
                            ? `$${record.totalAmountPaid.toFixed(2)}` 
                            : ''} 
                    </span> */}
                    {record.totalAmountPaid != null && (
                        <span style={{
                            color: '#28a745',       
                            fontWeight: 'bold',     
                            backgroundColor: '#e6f4ea', 
                            padding: '4px 8px',    
                            borderRadius: '6px',   
                            display: 'inline-block', 
                            minWidth: '70px',       
                            textAlign: 'center'
                        }}>
                            ${record.totalAmountPaid.toFixed(2)}
                        </span>
                    )}
                </div>
            )
        },
        {
            title: 'Action',
            dataIndex: 'Actions',
            key: 'Actions',
            render: (text, record) => (
                <div className='action-panel'>
                    <div>
                        <Tooltip placement="top" title="View Membership">
                            <Button onClick={() => this.showMembership(record.id)} type="primary" > View</Button>
                        </Tooltip>
                    </div>
                </div>
            )
        }]
        this.pendingcolumns = [{
            title: 'Applicant Name',
            dataIndex: 'applicantFullName',
            key: 'applicantFullName',
            render: (text, record) => (
                <div className='action-panel'>
                    <span>{record.firstName != "" ? record.lastName +", "+ record.firstName : ""}</span>
                </div>
            )
        }, {
            title: 'Member ID',
            dataIndex: 'memberID',
            key: 'memberID',
            render: (text, record) => (
                <div className='action-pane'>
                    <span>{record.memberID ? record.memberID : ''}</span>
                </div>
            )
        }, {
            title: 'Email',
            dataIndex: 'emailAddress',
            key: 'emailAddress',
            render: (text, record) => (
                <div className='action-pane'>
                    <span>{record.email ? record.email : ''}</span>
                </div>
            )
        },
        {
            title: 'Submitted Date',
            dataIndex: 'submittedDate',
            key: 'submittedDate',
            render: (text, record) => (
                <div className='action-panel'>
                    <span>{moment(record.submittedDate).format('MM/DD/YYYY')}</span>
                </div>
            )
        },
        {
            title: 'Membership Type',
            dataIndex: 'alumniMembershipLevelId',
            key: 'alumniMembershipLevelId',
            render: (text, record) => (
                <div className='action-panel'>
                    {record.alumniMembershipLevelId == 30 && <span>NESA 5 Yrs</span>}
                    {record.alumniMembershipLevelId == 32 && <span>NESA Lifetime</span>}
                </div>
            )
        },
        {
            title: 'Total Amount',
            dataIndex: 'totalAmountPaid',
            key: 'totalAmountPaid',
            render: (text, record) => (
                <div className='action-pane'>
                    {/* <span> 
                        {record.totalAmountPaid != null 
                            ? `$${record.totalAmountPaid.toFixed(2)}` 
                            : ''} 
                    </span> */}
                    {record.totalAmountPaid != null && (
                        <span style={{
                            color: '#856404',            
                            fontWeight: 'bold',          
                            backgroundColor: '#fff3cd', 
                            padding: '4px 8px',          
                            borderRadius: '6px',         
                            display: 'inline-block',   
                            minWidth: '70px',         
                            textAlign: 'center'
                        }}>
                            ${record.totalAmountPaid.toFixed(2)}
                        </span>
                    )}
                </div>
            )
        },
        {
            title: 'Action',
            dataIndex: 'Actions',
            key: 'Actions',
            render: (text, record) => (
                <div className='action-panel'>
                    <div>
                        <Tooltip placement="top" title="Activate Membership">
                            <Button onClick={() => this.showModal(record.id)} type="primary" > Manage</Button>
                        </Tooltip>
                    </div>
                </div>
            )
        }]
    }

    viewpending = () => {
        this.props.history.push('activate-membership');
    }

    showModal = (registrationid) => {
        this.setState({
            modalVisible: true,
            registrationID: registrationid
        });
    }

    showMembership = (registrationid) => {
        this.setState({
            membershipmodalVisible: true,
            registrationID: registrationid
        });
    }

    closeMembershipModal = () => {
        this.setState({
            membershipmodalVisible: false
        });
    }

    closeModal = () => {
        this.setState({
            modalVisible: false
        });
    }

    showDownloadCSV_pending_modal = () => {
        this.setState({
            Download_CSV_modal_Visible: true
        });
    }
    closeDownload_CSV_modal = () => {
        this.setState({
            Download_CSV_modal_Visible: false
        });
    }

    handleCSVDownload = (e) => {
        e.preventDefault();
        const PER_PAGE = 10000;
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {

                let membershipType = this.state.membershipType
                if ( this.state.fromDateCustom_err == undefined && this.state.ToDateCustom_err == undefined) {  
                this.props.actions.DownloadNESAMembership(1, PER_PAGE, 'ascend', membershipType, values);
                }
            }
        })
    }
    renderDownloadButton = () => {
        return <FormItem> <Button type="primary" className='membership-start' htmlType='submit' style={{ margin: "20px 0 0", float: 'unset', width: "100%", padding: "8px 0px", height: 'auto' }}
        disabled = {this.state.fromDateCustom_err || this.state.ToDateCustom_err}
        >
            {this.props.NESADownloads_Loading ? "DOWNLOADING..." : "DOWNLOAD"}</Button> </FormItem>
    }

    validateDates = (value, fieldName ) => {
        //this.validateDates(e.target.value, `${membershipType}CSV_downloadFrom`)
        let startDate, endDate = null;
        if (fieldName.includes('CSV_downloadFrom')) {
            startDate = value;
            endDate = this.state.endDate;
        }else{
            startDate = this.state.startDate;
            endDate = value;
        }

        if (startDate != null && endDate != null) {
            if (moment(startDate) > moment(endDate) && fieldName.includes('CSV_downloadFrom')) {     
                    this.setState({
                        fromDateCustom_err : "'From' date must be less than 'To' date.",
                        ToDateCustom_err : undefined
                    })
                }
            else if (moment(startDate) > moment(endDate) && fieldName.includes('CSV_downloadTo')) {     
                    this.setState({
                        fromDateCustom_err: undefined,
                        ToDateCustom_err : "'To' date must be greater than 'From' date."
                    })
                }
                else{
                    this.setState({
                        fromDateCustom_err: undefined,
                        ToDateCustom_err : undefined
                    })
                }
        }


                // if (fieldName.includes('pending')) {
                //     startDate = moment(values.pendingCSV_downloadFrom).format('YYYY-MM-DD')
                //     endDate = moment(values.pendingCSV_downloadTo).format('YYYY-MM-DD')

                // } else if (fieldName.includes('processed')) {
                //     startDate = moment(values.processedCSV_downloadFrom).format('YYYY-MM-DD')
                //     endDate = moment(values.processedCSV_downloadTo).format('YYYY-MM-DD')
                // } else if (fieldName.includes('denied')) {
                //     startDate = moment(values.deniedCSV_downloadFrom).format('YYYY-MM-DD')
                //     endDate = moment(values.deniedCSV_downloadTo).format('YYYY-MM-DD')
                // }
                
                // if (startDate < endDate) {     
                //     this.setState(
                //         CSVcustom_err = undefined
                //     )
                // }
                // else{
                //     this.setState(
                //         CSVcustom_err = "'To' date should be greater than 'From' date."
                //     )
                // }

    }
    DownloadCSV_modal_content = () => {
        const { getFieldDecorator, resetFields } = this.props.form;
        let membershipType = this.state.membershipType
        return <div className="centered steps-form" style={{ marginBottom: '40px' }} >
            <Form onSubmit={this.handleCSVDownload} className="search-form alumni-ui">
                <Row >
                    <Col xs={0} sm={0} md={2} lg={2} xl={2}></Col>
                    <Col xs={24} sm={24} md={10} lg={10} xl={10}>
                        <FormItem
                            label="From"
                            validateStatus={this.state.fromDateCustom_err != undefined ? "error"  : undefined}
                            hasFeedback
                            help={this.state.fromDateCustom_err != undefined ? this.state.fromDateCustom_err : undefined}
                        >
                            {getFieldDecorator(`${membershipType}CSV_downloadFrom`, {
                                initialValue: '' ,
                                rules: [
                                    { required: true, message: 'Enter "From" date!' },
                                    {
                                        pattern: /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/,
                                        message: `Please enter correct format MM/DD/YYYY Pattern`
                                    }
                                ],
                            })(
                                // <DatePicker style={{ width: '100%' }} format="MM/DD/YYYY" onChange={(value) => this.setDOB(value)} />
                                <InputMask
                                    mask="99/99/9999"
                                    placeholder='MM/DD/YYYY'
                                    alwaysShowMask
                                    maskChar={null}
                                    className="ant-input"
                                    onChange={(e) => {
                                        this.setState({startDate: e.target.value})
                                        this.validateDates(e.target.value, `${membershipType}CSV_downloadFrom`) }
                                    } 
                                    render={(ref, props) => (
                                        <Input />
                                    )}
                                />
                            )}
                        </FormItem>
                    </Col>
                    <Col xs={24} sm={24} md={10} lg={10} xl={10}>
                        <FormItem
                            label="To"
                            validateStatus={this.state.ToDateCustom_err != undefined ? "error"  : undefined}
                            hasFeedback
                            help={this.state.ToDateCustom_err != undefined ? this.state.ToDateCustom_err : undefined}
                        >
                            {getFieldDecorator(`${membershipType}CSV_downloadTo`, {
                                initialValue: '' ,
                                rules: [
                                    { required: true, message: 'Enter "To" date!' },
                                    {
                                        pattern: /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/,
                                        message: `Please enter correct format MM/DD/YYYY Pattern`
                                    }
                                ],
                            })(
                                // <DatePicker style={{ width: '100%' }} format="MM/DD/YYYY" onChange={(value) => this.setDOB(value)} />
                                <InputMask
                                    mask="99/99/9999"
                                    placeholder='MM/DD/YYYY'
                                    alwaysShowMask
                                    maskChar={null}
                                    className="ant-input"
                                    onChange={(e) => {
                                        this.setState({endDate: e.target.value})
                                        this.validateDates(e.target.value, `${membershipType}CSV_downloadTo`) }
                                    }
                                    render={(ref, props) => (
                                        <Input />
                                    )}
                                />
                            )}
                        </FormItem>
                    </Col>
                    <Col xs={0} sm={0} md={2} lg={2} xl={2}></Col>
                </Row>
                <Row>
                    <div >
                        Preparing csv file for <span style={{ fontWeight: 'bold' }}> {membershipType} Memberships </span>
                        from  <span style={{ fontWeight: 'bold' }}> mm/dd/yyyy </span>
                        to<span style={{ fontWeight: 'bold' }}> mm/dd/yyyy.</span>
                    </div>
                </Row>
                <Row style={{ display: 'flex', justifyContent: 'center' }}>
                    <Col className='xs-center sm-center' xs={14} sm={14} md={8} lg={8} xl={8}>
                        {this.renderDownloadButton()}
                    </Col>
                </Row>
            </Form>
        </div>
    }


    componentDidMount = () => {
        {
            this.props.isadmin &&
                this.props.actions.getPendingMemebrship(1, 10, this.state.SearchPending)
        }
        this.props.actions.getProcessedMembership(1, 10, this.state.SearchProcessed)
        this.props.actions.getDeniedMembership(1, 10, this.state.SearchDenied)

    }

    filtercallback(t) {
        if (this.props.searchvalue) {
            let searchValue = this.props.searchvalue
            if (t.applicantFullName.toLowerCase().includes(searchValue.toLowerCase())) {
                return true
            }
        } else if (!this.props.searchvalue) {
            return true
        }
        else {
            return false
        }
    }

    onChangepending = (page, pageSize) => {
        this.setState({
            page: page,
            // pagesize: pageSize,
            pendingpagesize: pageSize,
        })
        this.props.actions.getPendingMemebrship(page, pageSize, this.state.SearchPending);
    }

    onShowSizeChangepending(current, pageSize) {
        this.setState({
            page: current,
            // pagesize: pageSize,
            pendingpagesize: pageSize,
        })
        this.props.actions.getPendingMemebrship(current, pageSize, this.state.SearchPending);
    }

    onChangedenied = (page, pageSize) => {
        this.setState({
            page: page,
            // pagesize: pageSize,
            deniedpagesize: pageSize
        })
        this.props.actions.getDeniedMembership(page, pageSize, this.state.SearchDenied);
    }

    onShowSizeChangedenied(current, pageSize) {
        this.setState({
            page: current,
            // pagesize: pageSize,
            deniedpagesize: pageSize
        })
        this.props.actions.getDeniedMembership(current, pageSize, this.state.SearchDenied);
    }

    onChangeprocessed = (page, pageSize) => {
        this.setState({
            page: page,
            // pagesize: pageSize,
            processedpagesize: pageSize,
        })
        this.props.actions.getProcessedMembership(page, pageSize, this.state.SearchProcessed);
    }

    onShowSizeChangeprocessed(current, pageSize) {
        this.setState({
            page: current,
            // pagesize: pageSize,
            processedpagesize: pageSize,
        })
        this.props.actions.getProcessedMembership(current, pageSize, this.state.SearchProcessed);
    }

    showTotal = (total) => {
        return `Total ${total} Pending Memberships`;
    }


    renderPendingMembership = (memberships) => {
        if (this.props.pendingmembership) {
            let pendingmembership = this.props.pendingmembership
            return <div>
                <Table
                    ref={el => (this.componentRef = el)}
                    bordered
                    dataSource={memberships}
                    columns={this.pendingcolumns}
                    pagination={{ onChange: this.onChangepending, defaultPageSize: this.state.pendingpagesize, showSizeChanger: true, onShowSizeChange: this.onShowSizeChangepending, defaultCurrent: this.state.page, showTotal: (total, range) => `${range[0]}-${range[1]} of ${pendingmembership.totalNumberOfRecords} Pending Memberships`, total: pendingmembership.totalNumberOfRecords, size: 'small' }}
                />
            </div>
        } else {
            return <div>
                <Spin indicator={LoadingIcon} className="loading-state" tip="Loading Pending Memberships..." />
            </div>
        }
    }

    SearchPending = (e) => {
        this.setState({ SearchPending: e.target.value })
        this.SearchPendingMembership()
    };

    SearchPendingMembership = debounce(() => {
        this.props.actions.getPendingMemebrship(1, 40, this.state.SearchPending)
    }, 1000)

    SearchProcessed = (e) => {
        this.setState({ SearchProcessed: e.target.value })
        this.SearchProcessedMembership()
    }

    SearchProcessedMembership = debounce(() => {
        this.props.actions.getProcessedMembership(1, 40, this.state.SearchProcessed)
    }, 1000)

    SearchDenied = (e) => {
        this.setState({ SearchDenied: e.target.value })
        this.SearchDeniedMembership()
    }

    SearchDeniedMembership = debounce(() => {
        this.props.actions.getDeniedMembership(1, 40, this.state.SearchDenied)
    }, 1000)

    componentWillReceiveProps = (nextprops) => {
        // if (nextprops.activation_status) {
        //     if (nextprops.activation_status.message) {
        //         this.setState({
        //             modalVisible: false
        //         })
        //     }
        // }

        if (nextprops.CSVRecords_maximum) {
            this.setState({
                Max_CSV_Records_Modal_Visible: true
            })
        }

    }

    closeMaxCSVRecordsModal = () => {
        this.props.actions.closeCsvMaximumDownloaded();
        this.setState({
            Max_CSV_Records_Modal_Visible: false
        })
    }

    renderProcessedMembership = (memberships) => {
        if (this.props.processedmembership) {
            let processedmembership = this.props.processedmembership

            let filteredRegistrations = processedmembership.registrations
                ? processedmembership.registrations.filter(
                    item => item.totalAmountPaid > 0
                )
                : [];
            
            return <div>
                <Table
                    ref={el => (this.componentRef = el)}
                    bordered
                    dataSource={filteredRegistrations}
                    columns={this.processedcolumns}
                    pagination={{ onChange: this.onChangeprocessed, defaultPageSize: this.state.processedpagesize, showSizeChanger: true, onShowSizeChange: this.onShowSizeChangeprocessed, defaultCurrent: this.state.page, showTotal: (total, range) => `${range[0]}-${range[1]} of ${processedmembership.totalNumberOfRecords} Processed Memberships`, total: processedmembership.totalNumberOfRecords, size: 'small' }}
                />
            </div>

        } else {
            return <div>
                <Spin indicator={LoadingIcon} className="loading-state" tip="Loading Processed Memberships..." />
            </div>
        }
    }

    renderDeniedMembership = (memberships) => {
        if (this.props.deniedmemberships) {
            let deniedmemberships = this.props.deniedmemberships
            return <div>
                <Table
                    ref={el => (this.componentRef = el)}
                    bordered
                    dataSource={deniedmemberships.registrations}
                    columns={this.deniedcolumns}
                    pagination={{ onChange: this.onChangedenied, defaultPageSize: this.state.deniedpagesize, showSizeChanger: true, onShowSizeChange: this.onShowSizeChangedenied, defaultCurrent: this.state.page, showTotal: (total, range) => `${range[0]}-${range[1]} of ${deniedmemberships.totalNumberOfRecords} Denied Memberships`, total: deniedmemberships.totalNumberOfRecords, size: 'small' }}
                />
            </div>
        } else {
            return <div>
                <Spin indicator={LoadingIcon} className="loading-state" tip="Loading Denied Memberships..." />
            </div>
        }
    }

    // changeTab = activeKey => {
    //     // if(activeKey == 1){
      
    //     // }
    //     if (activeKey == 1 && this.props.pendingmembership == undefined) {
    //         this.props.actions.getPendingMemebrship(1, 10, this.state.SearchPending)
    //     }
    //     this.setState({
    //         fromDateCustom_err: undefined,
    //         ToDateCustom_err: undefined
    //     })
    //     // if (activeKey == 2 ) {
            
    //     // }
    //     // if (activeKey == 3 ) {
            
    //     // }
    // }

    changeTab = activeKey => {
        this.setState({ activeTabKey: activeKey, fromDateCustom_err: undefined, ToDateCustom_err: undefined });

        if (activeKey === "1" && this.props.pendingmembership == undefined) {
            this.props.actions.getPendingMemebrship(1, 10, this.state.SearchPending);
        }
        if (activeKey === "2" && this.props.processedmembership == undefined) {
            this.setState({
                activeTabKey: "2"
            });
            this.props.actions.getProcessedMembership(1, 10, this.state.SearchProcessed);
        }
        if (activeKey === "3" && this.props.deniedmemberships == undefined) {
            this.setState({
                activeTabKey: "3"
            });
            this.props.actions.getDeniedMembership(1, 10, this.state.SearchDenied);
        }
    };

    getTodaysPurchaseCount(registrations) {
        const today = new Date().toISOString().split('T')[0];
        return (registrations || []).filter(p => p.submittedDate === today && p.totalAmountPaid > 0).length;
    }

    getTodaysPendingCount(registrations) {
        const today = new Date().toISOString().split('T')[0];
        return (registrations || []).filter(p => p.submittedDate === today).length;
    }

    render() {
        const { processedmembership, pendingmembership, loading, processedLoading } = this.props;

        const todayProcessedCount = processedLoading || !processedmembership
            ? null
            : this.getTodaysPurchaseCount(processedmembership.registrations);

        const todayPendingCount = loading || !pendingmembership
            ? null
            : this.getTodaysPendingCount(pendingmembership.registrations);

        const isPendingSearching = this.state.SearchPending && this.state.SearchPending.trim() !== "";
        const isProcessedSearching = this.state.SearchProcessed && this.state.SearchProcessed.trim() !== "";

        return (
            <div>
                <LayoutHeader />
                <AdminNavigation />
                <div className='widget'>
                    <div className='dashboard-container dashboard-table'>
                        <Modal
                            className='PendingModal width-auto'
                            title="Download CSV"
                            centered
                            visible={this.state.Download_CSV_modal_Visible}
                            onOk={() => this.closeDownload_CSV_modal()}
                            onCancel={() => this.closeDownload_CSV_modal()}
                            footer={null}
                        >
                            {this.DownloadCSV_modal_content()}
                        </Modal>
                        <Tabs onChange={this.changeTab} activeKey={this.state.activeTabKey}>
                            {this.props.isadmin &&
                                <TabPane className="alumni-tab" tab="PENDING MEMBERSHIPS" key="1">
                                    <div className='tab-container'>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 0' }}>

                                            <div style={{ minWidth: '200px' }}>
                                                {!isPendingSearching && (
                                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                                                        <span style={{ fontSize: '16px', color: '#555' }}>Today's Pending <Icon style={{ fontSize: '18px', color: '#cd1a1aff' }} type="fall" /></span>
                                                        <span style={{ fontSize: '24px', fontWeight: 'bold', color: '#000' }}>
                                                            {todayPendingCount === null ? <Spin size="small" /> : (todayPendingCount < 10 ? `0${todayPendingCount}` : todayPendingCount)}
                                                        </span>
                                                    </div>
                                                )}
                                            </div>

                                             <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                {this.props.isadmin &&
                                                    <Button
                                                        type='default'
                                                        style={{ color: "#515354", background: "transparent", border: 'none' }}
                                                        onClick={() => {
                                                            this.setState({ membershipType: "pending" });
                                                            this.showDownloadCSV_pending_modal();
                                                        }}
                                                    >
                                                        Download CSV
                                                        <i className="fa fa-cloud-download" style={{ fontSize: '20px', marginLeft: '5px' }}></i>
                                                    </Button>
                                                }
                                                <Input
                                                    name="txt_search"
                                                    onChange={this.SearchPending}
                                                    className="searchInput"
                                                    size="small"
                                                    prefix={<i className="fa fa-search" />}
                                                    placeholder="Search by Last Name"
                                                    style={{ width: '300px' }}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className='tab-body'>
                                        {this.renderPendingMembership(this.props.pendingmembership ? this.props.pendingmembership.registrations.filter(this.filtercallback) : null)}
                                    </div>
                                </TabPane>
                            }

                            <TabPane className="alumni-tab" tab="PROCESSED MEMBERSHIPS" key="2">
                                <div className='tab-container'>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 0' }}>
                                    
                                        <div style={{ minWidth: '200px' }}>
                                            {!isProcessedSearching && (
                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '5px', paddingLeft: '10px' }}>
                                                    <span className='ant-statistic-title' style={{ fontSize: '16px', color: '#555' }}>Today's Purchases  <Icon style={{ fontSize: '18px', color: '#28a745' }} type="rise" /></span>
                                                    <span className='ant-statistic-content' style={{ fontSize: '24px', fontWeight: 'bold', color: '#000' }}>
                                                        {todayProcessedCount === null ? <Spin size="small" /> : (todayProcessedCount < 10 ? `0${todayProcessedCount}` : todayProcessedCount)}
                                                    </span>
                                                </div>
                                            )}
                                        </div>

                                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            {this.props.isadmin &&
                                                <Button
                                                    type='default'
                                                    style={{ color: "#515354", background: "transparent", border: 'none' }}
                                                    onClick={() => {
                                                        this.setState({ membershipType: "processed" });
                                                        this.showDownloadCSV_pending_modal();
                                                    }}
                                                >
                                                    Download CSV
                                                    <i className="fa fa-cloud-download" style={{ fontSize: '20px', marginLeft: '5px' }}></i>
                                                </Button>
                                            }

                                            <Input
                                                name="txt_search"
                                                onChange={this.SearchProcessed}
                                                className="searchInput"
                                                size="small"
                                                prefix={<i className="fa fa-search" />}
                                                placeholder="Search by Last Name"
                                                style={{ width: '300px' }}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className='tab-body'>
                                    {this.renderProcessedMembership(this.props.processedmembership ? this.props.processedmembership.registrations.filter(this.filtercallback) : null)}
                                </div>
                            </TabPane>

                            <TabPane className="alumni-tab" tab="DENIED MEMBERSHIPS" key="3">
                                <div className='tab-container'>
                                    <Row>
                                        <Col span={6}>
                                            {
                                                this.props.isadmin == true &&
                                                // this.MembershipDownload()
                                                <div className="content-filter" style={{ background: "transparent", fontSize: '15px', padding: "10px 0px", fontWeight: 'normal', justifyContent: 'flex-start' }}>
                                                    {/* {this.props.NESApendingMembershipCSV ? */}
                                                    <label className="downloadBtn pointer" >
                                                        <Button type='default' style={{ color: "#515354", background: "transparent", border: 'none' }}
                                                            onClick={() => {
                                                                this.setState({ membershipType: "denied" })
                                                                this.showDownloadCSV_pending_modal()
                                                            }}
                                                        >
                                                            Download CSV
                                                            <i className="fa fa-cloud-download margin-left-5" style={{ fontSize: '20px' }}></i>
                                                        </Button>
                                                    </label>
                                                </div>
                                            }
                                        </Col>
                                        <Col span={8} offset={10}>
                                            <Input name="txt_search" onChange={this.SearchDenied} className="searchInput" size="small" prefix={< Icon type="search" />} placeholder="Search by Last Name" />
                                        </Col>
                                    </Row>

                                </div>
                                <div className='tab-body'>
                                    {this.renderDeniedMembership(this.props.processedmembership ? this.props.processedmembership.registrations.filter(this.filtercallback) : null)}
                                </div>
                            </TabPane>
                        </Tabs>
                    </div>
                </div>

                <Modal
                    className='PendingModal width-auto'
                    title="View Membership"
                    centered
                    visible={this.state.membershipmodalVisible}
                    destroyOnClose={true}
                    onOk={() => this.closeMembershipModal()}
                    onCancel={() => this.closeMembershipModal()}
                    footer={null}
                >
                    <ViewMembership registrationID={this.state.registrationID} />
                </Modal>

                <Modal
                    className='PendingModal width-auto'
                    title="Activate Membership"
                    centered
                    visible={this.state.modalVisible}
                    destroyOnClose={true}
                    onOk={this.closeModal}
                    onCancel={this.closeModal}
                    footer={null}
                >
                    <ActivateMembership 
                        registrationID={this.state.registrationID} 
                        pendingPerPageSize={this.state.pendingpagesize} 
                        onMembershipDenied={() => {
                            this.setState({
                                modalVisible: false,
                                activeTabKey: "3"
                            });
                        }}
                        onMembershipProcessed={() => {
                            this.setState({
                                modalVisible: false,
                                activeTabKey: "2"
                            });
                        }}
                    />
                </Modal>

                <Modal
                    className='MaxCSVRecordsModal'
                    centered
                    visible={this.state.Max_CSV_Records_Modal_Visible}
                    closable={false}
                    footer={
                        <Button key="back" className="CloseMaximumCSVRecordsModal" onClick={this.closeMaxCSVRecordsModal}>
                            Close
                        </Button>
                    }
                >
                    <div className='MaxCSVReachedWarning'>
                        <img src={warningAlert} className='MaximumRecordsAlert' width="40px" height="40px" />
                    </div>

                    <p className='MaximumRecordsInfo'>
                        The number of records existing in the specified date range exceed the maximum amount. 
                        Please reset your date range and resubmit your download request.
                    </p>
                </Modal>

            </div>

        );
    }

}


function mapStateToProps(state) {
    return {
        loading: state.pendingmembershipreducer.loading,
        pendingmembership: state.pendingmembershipreducer.pendingmembership,
        processed_loading: state.pendingmembershipreducer.pendingmembership,
        processedmembership: state.processedmembershipreducer.processedmemberships,
        processedLoading: state.processedmembershipreducer.loading,
        deniedmemberships: state.deniedmembershipreducer.deniedmemberships,
        searchvalue: state.searchpendingmembershipreducer.value,
        activation_loading: state.activateMembershipreducer.loading,
        activation_status: state.activateMembershipreducer.status,
        isadmin: state.isadminreducer.isadmin,
        NESADownloads_Loading: state.NESAMembershipDownloadsreducer.loading,
        CSVRecords_maximum: state.NESAMembershipDownloadsreducer.maxCSVRecords,
        NESAMembershipCSV: state.NESAMembershipDownloadsreducer.NESAMembershipCSV,

        denyToPending_loading: state.denyToPendingMembershipreducer.loading,
        denyToPendingStatus: state.denyToPendingMembershipreducer.status,

    }
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators(actions, dispatch) }
}

const PendingMembership = Form.create()(PendingMembershipForm);

export default connect(mapStateToProps, mapDispatchToProps)(PendingMembership);


// WEBPACK FOOTER //
// ./src/components/Membership/PendingMembership.js